import type { ScreenSchema } from './types';

/**
 * Schema for email and email-plain templates.
 *
 * Audible content:
 *   - `intro`          — standard uc-content block (heading → text → instructions)
 *   - `email-feedback` — post-submit feedback text read via play() in screen-email.vue
 *                        S3 key: `{screen.id}-email-feedback`
 *
 * Note: email subject / body sentences are not narrated via schema — they are the
 * interactive content the learner reads and flags. Only the framing copy is narrated.
 */
const emailSchema: ScreenSchema = {
  template: ['email', 'email-plain'],
  slots: {
    intro: {
      parts: [
        { field: 'heading', fallback: ['subheading', 'title'] },
        { field: 'text' },
        { field: 'instructions' }
      ]
    },
    'email-feedback': {
      parts: [{ field: 'email.feedback' }]
    }
  }
};

export default emailSchema;
